import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilsSharedModule } from '../utils/utils/utils.module';
import { ConstantsModule } from '../constants/constants.module';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})


export class BreadcrumbComponent implements OnInit {

  @Input() inputData = [];
  @Output() eventEmitter = new EventEmitter<Object>();
  
  breadCrumbs: any;


  constructor(
    public constants: ConstantsModule,
    public utils: UtilsSharedModule
  ) { }

  ngOnInit() {
  }

  ngOnChanges(){
    if(this.inputData && this.inputData.length >0){
    }
  }

  ifNotLast(clikedLocation): boolean{
    return (this.inputData.length -1 != this.inputData.findIndex(location =>location['locationUUID'] == clikedLocation['locationUUID'] ))?true:false;
  }

  navigate(location){
    let index = this.inputData.findIndex(locObj =>locObj['locationUUID']==location['locationUUID']);    
    let length = this.inputData.length;
    this.inputData.splice(index+1, length - index + 1);
    let obj = {}
    obj['selectedLocation'] = location;
    obj['currentBreadcrumb'] = this.inputData; 
    this.eventEmitter.emit(obj);
    // this.router.navigateByUrl(this.utils.fixedEncodeURIComponent(item.url));
  }

}
